const appIds = {
  googleTags: 'GTM-N57CP99',
  helphero: 'p0PIMvy2f6',
  bugsnag: 'fdc40d945e74ae6ee1c9f9b0bbda96b0',
};

const APP_VERSION = '0.1.0';

export { appIds, APP_VERSION };
